import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '@financial/shared';
import { api } from '../../lib/api';

/**
 * Estado y versión del API desplegado. Es una ruta pública y el valor sólo
 * cambia cuando se despliega, así que se cachea de forma agresiva.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: async (): Promise<HealthResponse> => {
      const res = await api.get<HealthResponse>('/health');
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
